export default {
  "idChallenge": "c815a167-7759-45be-a3de-560e692117d8",
  "preguntas": {
  "Primera": {
    "id": "1",
      "text": "¿En qué mes nació uno de sus hermanos (as)?",
      "opciones": {
      "opcion1": {
        "id": "1",
          "texto": "OCTUBRE"
      },
      "opcion2": {
        "id": "2",
          "texto": "MARZO"
      },
      "opcion3": {
        "id": "3",
          "texto": "JULIO"
      },
      "opcion4": {
        "id": "4",
          "texto": "NOVIEMBRE"
      },
      "opcion5": {
        "id": "5",
          "texto": "NINGUNA DE LAS ANTERIORES"
      }
    }
  },
  "Segunda": {
    "id": "2",
      "text": "¿Cuál es el segundo apellido de su Madre?",
      "opciones": {
      "opcion1": {
        "id": "1",
          "texto": "FERNANDEZ"
      },
      "opcion2": {
        "id": "2",
          "texto": "CASTRO"
      },
      "opcion3": {
        "id": "3",
          "texto": "TORRES"
      },
      "opcion4": {
        "id": "4",
          "texto": "GONZALEZ"
      },
      "opcion5": {
        "id": "5",
          "texto": "NINGUNA DE LAS ANTERIORES"
      }
    }
  },
  "Tercera": {
    "id": "3",
      "text": "¿En cuál de los siguientes Colegios o Liceos estuvo usted el año 2008?",
      "opciones": {
      "opcion1": {
        "id": "1",
          "texto": "CENTRO EDUC PROFES GMO GONZALEZ HEINRICH"
      },
      "opcion2": {
        "id": "2",
          "texto": "ESCUELA RURAL DE PICHI PICHIL"
      },
      "opcion3": {
        "id": "3",
          "texto": "ESCUELA RURAL AGUAS BUENAS"
      },
      "opcion4": {
        "id": "4",
          "texto": "ESCUELA RURAL EL PALOMAR"
      },
      "opcion5": {
        "id": "5",
          "texto": "NINGUNA DE LAS ANTERIORES"
      }
    }
  },
  "Cuarta": {
    "id": "4",
      "text": "¿Cuál es el segundo nombre de su Padre?",
      "opciones": {
      "opcion1": {
        "id": "1",
          "texto": "ANDRES"
      },
      "opcion2": {
        "id": "2",
          "texto": "IGNACIO"
      },
      "opcion3": {
        "id": "3",
          "texto": "HERNAN"
      },
      "opcion4": {
        "id": "4",
          "texto": "CARLOS"
      },
      "opcion5": {
        "id": "5",
          "texto": "NINGUNA DE LAS ANTERIORES"
      }
    }
  }
},
  "codigo": 10,
  "mensaje": "Acción realizada satisfactoriamente",
  "fecha": "2024-04-11 11:41:07",
  "seguimientoId": "c00ae86e-9875-47ce-8389-93a4483bc218",
  "duracion": 4323
}
